// =============================================================
// useSeo —— 页面级 SEO / GEO 元信息管理 composable（Vue 2 适配）
// 在 App.vue 的 created 挂载，监听路由变化：
//   - 动态更新 <title>、<meta name="description">、keywords
//   - 动态更新 canonical、Open Graph / Twitter、robots
//   - 注入当前路由对应的 JSON-LD 结构化数据
//   用法：在 Watch 路由时手动调用 applySeo(route)。
// =============================================================
import { SITE, routeMeta } from '@site/data/seo'
import { buildJsonLd } from '@site/composables/useJsonLd'

const SITE_URL = SITE.url

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function removeJsonLdScripts() {
  document.querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove())
}

function joinPath(path) {
  return path === '/' ? SITE_URL : `${SITE_URL}${path}`
}

export function applySeo(currentRoute) {
  const meta = routeMeta[currentRoute.name] || {}

  document.title = meta.title || SITE.fullName
  document.documentElement.lang = SITE.lang

  upsertMeta('name', 'description', meta.description || SITE.description)
  upsertMeta('name', 'keywords', meta.keywords || SITE.keywords)

  // Canonical
  upsertLink('canonical', joinPath(meta.path || currentRoute.path))

  // Open Graph
  upsertMeta('property', 'og:type', meta.ogType || 'website')
  upsertMeta('property', 'og:title', meta.title || SITE.fullName)
  upsertMeta('property', 'og:description', meta.description || SITE.description)
  upsertMeta('property', 'og:url', joinPath(meta.path || currentRoute.path))
  upsertMeta('property', 'og:site_name', SITE.name)
  upsertMeta('property', 'og:locale', 'zh_CN')
  upsertMeta('property', 'og:image', `${SITE_URL}${SITE.ogImage}`)

  // Twitter Card
  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', meta.title || SITE.fullName)
  upsertMeta('name', 'twitter:description', meta.description || SITE.description)
  upsertMeta('name', 'twitter:image', `${SITE_URL}${SITE.ogImage}`)

  // robots
  upsertMeta('name', 'robots', 'index,follow')

  // JSON-LD 结构化数据
  removeJsonLdScripts()
  const schemas = buildJsonLd(currentRoute)
  schemas.forEach((schema) => {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.setAttribute('data-seo-jsonld', 'true')
    script.textContent = JSON.stringify(schema)
    document.head.appendChild(script)
  })
}

export { SITE }



// WEBPACK FOOTER //
// ./src/site/composables/useSeo.js